module.exports = __webpack_public_path__ + "static/media/resume.a339f532.pdf";